import {
  buildSearchBox,
  buildPager,
  buildResultList,
  loadFieldActions,
  buildRelevanceSortCriterion,
  buildDateSortCriterion,
  buildSort,
  SortOrder,
  buildFacet,
  buildResultsPerPage,
  buildInteractiveResult,
  // registerFields
  // buildSearchEngine,
  // getOrganizationEndpoints
} from '@coveo/headless';

const FIELDS = ['commonformat', 'sitemapdescription', 'sitemaplastmodified'];
export const registerFields = (engine) => {
  const fieldActions = loadFieldActions(engine);
  engine.dispatch(fieldActions.registerFieldsToInclude(FIELDS));
  return engine;
};

// ==== EXAMPLE ====
// INFO: need to create baseEngine in CoveoSearchPage
// response.token from useGetCoveoAuthentication graphql call
// const baseEngine = buildSearchEngine({
//   configuration: {
//     organizationId: CONFIG('COVEO_ORG_ID'),
//     organizationEndpoints: getOrganizationEndpoints(CONFIG('COVEO_ORG_ID')),
//     accessToken: $response.token$, // typeof string
//     // renewAccessToken: () => {}, // callback
//     search: {
//       pipeline: 'PortalSearch',
//       searchHub: 'PortalSearch',
//     },
//   },
// });

// const registeredFields = registerFields(baseEngine);
// setHeadlessEngine(registeredFields)
// ==================

// Sortion Criteria Options
// returns [['Relevance', {by: 'relevancy'}], ['Date (Ascending)', {by: 'date', order: 'ascending''}], ['Date (Descending)', {by: 'date', order: 'descending'}]]
export const criteria = [
  ['relevancy', buildRelevanceSortCriterion()],
  ['date descending', buildDateSortCriterion(SortOrder.Descending)],
  ['date ascending', buildDateSortCriterion(SortOrder.Ascending)],
];

const initialCriterion = criteria[0][1];
const facetBuilder = (engine, field) => {
  return buildFacet(engine, { options: { field } });
};

export const coveo = {
  controllers: {
    searchBox: (engine) =>
      buildSearchBox(engine, { options: { id: 'search-box' } }),
    pager: (engine) => buildPager(engine, { options: { numberOfPages: 8 } }),
    resultsPerPage: (engine) => buildResultsPerPage(engine),
    resultList: (engine) => buildResultList(engine),
    sorter: (engine) =>
      buildSort(engine, { initialState: { criterion: initialCriterion } }),
    interactiveResults: (engine, result) =>
      buildInteractiveResult(engine, { options: { result } }),
  },
  facets: {
    location: (engine) => facetBuilder(engine, 'commonstate'),
    medicalSpecialty: (engine) => facetBuilder(engine, 'commonspecialty'),
    plans: (engine) => facetBuilder(engine, 'commonproductcategory'),
    serviceArea: (engine) => facetBuilder(engine, 'commonservicearea'),
    resourceType: (engine) => facetBuilder(engine, 'commonresourcetype'),
  },
};
